import { Brain, GraduationCap, HeartHandshake, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";

export default function AboutPage() {
  return (
    <div className="container-x py-16">
      <Seo title="À propos" description="Beehive Enfance et Éducation Academy : rendre simples et accessibles les connaissances sur le cerveau de l'enfant pour les professionnels de la petite enfance." />
      <div className="max-w-3xl">
        <h1 className="font-display text-4xl sm:text-5xl font-bold text-slate-900 tracking-tight">À propos.</h1>
        <p className="mt-6 text-lg text-slate-600 leading-relaxed">
          <b>L'Académie est l'espace de formation de Beehive Enfance et Éducation.</b> Notre mission est de
          rendre simples et accessibles les connaissances sur le fonctionnement du cerveau de l'enfant, afin de
          mieux accompagner chaque enfant dans son développement global.
        </p>
        <a
          href="https://www.beehive-enfance-et-education.com/"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="about-beehive-link"
          className="inline-flex items-center gap-1 mt-4 text-sm font-semibold text-brand-700 hover:text-brand-800"
        >
          En savoir plus sur Beehive →
        </a>
      </div>

      <div className="mt-16 grid gap-6 md:grid-cols-2 lg:grid-cols-4">
        {[
          { icon: Brain, title: "Ancré dans la science", text: "Nos contenus s'appuient sur la recherche en neurosciences affectives et cognitives." },
          { icon: HeartHandshake, title: "Pensé pour le terrain", text: "Chaque module a été testé et affiné auprès de vraies équipes." },
          { icon: GraduationCap, title: "Reconnu", text: "Une attestation de participation est délivrée à l'issue de chaque formation." },
          { icon: Sparkles, title: "Conçu par des experts", text: "Des contenus élaborés par des experts de la petite enfance." },
        ].map((b) => (
          <div key={b.title} className="card-soft p-6">
            <div className="grid place-items-center h-11 w-11 rounded-2xl bg-brand-100 text-brand-700 mb-4"><b.icon strokeWidth={1.5} size={20} /></div>
            <h3 className="font-display font-bold text-slate-900">{b.title}</h3>
            <p className="text-sm text-slate-600 mt-1.5 leading-relaxed">{b.text}</p>
          </div>
        ))}
      </div>

      <div className="mt-20 grid lg:grid-cols-5 gap-12">
        <div className="lg:col-span-3">
          <h2 className="font-display text-3xl font-bold tracking-tight text-slate-900">Nos valeurs</h2>
          <ul className="mt-5 space-y-3 text-slate-700 leading-relaxed">
            <li>• <b>L'Excellence</b> : nous nous appuyons sur les données probantes et les connaissances scientifiques les plus récentes.</li>
            <li>• <b>La Bienveillance</b> : nous plaçons le respect de l'enfant et des professionnels au cœur de nos pratiques.</li>
            <li>• <b>L'Impact</b> : nous transformons les connaissances en pratiques concrètes, utiles au quotidien.</li>
            <li>• <b>La Collaboration</b> : nous favorisons le partage des savoirs et l'apprentissage collectif.</li>
          </ul>
        </div>
        <div className="lg:col-span-2 space-y-6">
          <div className="card-soft p-8">
            <div className="eyebrow mb-2">Réseau d'experts</div>
            <h3 className="font-display font-bold text-xl text-slate-900">Rejoindre le réseau d'experts</h3>
            <p className="text-sm text-slate-600 mt-2 leading-relaxed">Vous êtes expert de la petite enfance, du développement de l'enfant ou d'un domaine associé ? Rejoignez le réseau d'experts de Beehive Academy et partagez votre expertise à travers nos formations.</p>
            <Link to="/experts" data-testid="about-experts-link" className="btn-primary mt-5 w-full text-sm">Déposer mon profil</Link>
          </div>
          <div className="card-soft p-8">
            <div className="eyebrow mb-2">Communauté</div>
            <h3 className="font-display font-bold text-xl text-slate-900">Contribuer à la communauté</h3>
            <p className="text-sm text-slate-600 mt-2 leading-relaxed">Vous souhaitez partager une réflexion, une pratique ou un article avec notre communauté ?</p>
            <Link to="/blog" data-testid="about-contribute-link" className="btn-outline mt-5 w-full text-sm">Proposer un article</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
